import { Injectable, inject } from '@angular/core'
import { Router } from '@angular/router'
import { TENANT_MENUS } from '@ui-core/constants/menu.constant'
import { RoutesEnum } from '@ui-core/enums/routes.enum'
import { UserRolesConditionEnum } from '@ui-core/enums/user-roles.enum'
import { ConfigInterface } from '@ui-core/interfaces/config.interface'
import { TenantMenuItem } from '@ui-core/interfaces/menu.interface'
import { MenuItem } from 'primeng/api'
import { environment } from '../../../app/load.env'
import { ApiUrlService } from './api-url.service'
import { MenuService } from './menu.service'
import { UserService } from './user.service'

@Injectable({
    providedIn: 'root'
})
export class InitService {
    private apiUrlService = inject(ApiUrlService)
    private menuService = inject(MenuService)
    private userService = inject(UserService)
    private router = inject(Router)

    initApiUrl(): this {
        this.apiUrlService.setApiUrl(environment.API_URL || '')
        return this
    }

    async loadMenuFor(tenant: string): Promise<TenantMenuItem> {
        const loader = TENANT_MENUS[tenant]

        if (!loader) {
            this.router.navigate([RoutesEnum.FORBIDDEN])
            return { tenant, menu: [], userMenu: [] }
        }

        const menus = await loader()
        return menus
    }

    async initMenu(tenant: string): Promise<this> {
        const tenantMenu = await this.loadMenuFor(tenant)
        const menu = this.filterRoleCondition(tenantMenu?.menu || [])
        this.menuService.set(menu)

        return this
    }

    async initUserMenu(tenant: string): Promise<this> {
        const tenantMenu = await this.loadMenuFor(tenant)
        const menu = this.filterRoleCondition(tenantMenu?.userMenu || [])
        this.menuService.setUserMenu(menu)

        return this
    }

    getConfig(): ConfigInterface {
        return environment
    }

    filterRoleCondition(options: MenuItem[]): MenuItem[] {
        const finalMenu: MenuItem[] = []

        options.forEach((option) => {
            if (
                option.state &&
                option.state['roleCondition'] &&
                option.state['roleCondition'] === UserRolesConditionEnum.Any
            ) {
                if (this.userService.hasAnyRole(option.state['role'])) {
                    finalMenu.push(option)
                }
            }

            if (
                option.state &&
                option.state['roleCondition'] &&
                option.state['roleCondition'] === UserRolesConditionEnum.All
            ) {
                if (this.userService.hasRoles(option.state['role'])) {
                    finalMenu.push(option)
                }
            }
        })

        return finalMenu
    }
}
